export default __webpack_public_path__ + "static/media/relative_humidity.77e75394.svg";